
/**サンプルです */
export const SAMPLE_01 = "01";

// エクセル拡張子
export const EXCEL_EXTENSION = '.xlsx';

/**
 * 編集モード
 */
export enum GridMode {
    EDIT,
    REFER,
    IMPORT
}

/** spreadの初期拡大率 ： 0.85% */
export const SPREAD_INITIAL_ZOOM = 0.85;

/**読み取り専用セル背景色 */
export const READONLY_BACKCOLOR = '#ccffcc';

//#4108で#c7dfb4→#ccffccに変更→読み取り専用セルとは別の定数にしておく
/**作業デフォルト背景色 */
export const WORK_BACKCOLOR = '#ccffcc';

/** シート名最大文字数 */
export const MAX_SHEET_NAME_LENGTH = 31;

/** アップロード可能なアップロードファイルサイズ30MB */
export const MAX_FILESIZE = 30;

/** ダウンロード時の画面名 */
export const V_CUSTOMER_FACTORY_MASTER = '顧客・工場マスタ';
export const V_COMPANY_INFO = '会社情報';
export const V_PLANT_INFO = 'プラント情報';
export const V_CATEGORY_INFO = 'カテゴリ情報';
//export const V_PROGRESS_HISTORY_MANAGEMENT = '進捗履歴・最新実績管理';
export const V_PROGRESS_HISTORY_INFO = '進捗履歴情報';
export const V_PROGRESS_INFO = '進捗情報';
export const V_PLANT_CATEGORY_COMPANY_SETTING = 'プラントカテゴリ会社設定';
export const V_TESTSYSTEM_LEGISLATION_INFO = 'テスト系統・法規情報';
export const V_WORK_CHARGE_INFO = '作業担当情報';
export const V_EQUIPMENT_INFO = '機器・工事情報';
export const V_ESSENTIAL_WORK_INFO = '必須作業情報';
export const V_WORK_INFO = '作業情報';
export const V_USER_INFO = 'ユーザ情報';
export const V_EQUIPMENT_USER_INFO = '機器担当ユーザ設定';
export const V_WORK_CHARGE_USER_BY_COMPANY = '作業担当ユーザ設定(所属会社毎)';
export const V_WORK_CHARGE_USER_BY_USER = '作業担当ユーザ設定(ユーザ毎)';
export const V_APPROVE_WORK_CHARGE_SETTING = '承認作業担当設定';
export const V_APPROVE_HOLD_SETTING = 'ホールド設定';

export const V_PROGRESS_MANAGEMENT_NORMAL = '進捗表(通常)';
export const V_VIEW_PROGRESS_ = 'ビュー進捗表';
export const V_PROCESS_MANAGEMENT = '工程表';
export const V_SCHEDULE_APPROVAL = '予定承認表';
export const V_ADDITIONAL_EQUIPMENT_INFO = '追加工事管理';
export const V_SUMMARY_GRAPH = 'サマリグラフ';
export const V_SUMMARY_MEETING = 'サマリ表(ミーティング)';
export const V_SUMMARY_WHOLE = 'サマリ表(全体)';
export const V_SUMMARY_INCOMPLETE = 'サマリ表(未完了)';
export const V_SUMMARY_TEST_SYSTEM = 'サマリ表(テスト系統)';
export const V_SUMMARY_LEGISLATION = 'サマリ表(法規)';

/** 機器工事フォルダ作成時の画面名 */
export const V_HOME = 'ホーム';
export const V_PROJECT_MASTER_DETAIL = 'プロジェクトマスタ詳細';

/** 進捗表エクスポート 凡例(進捗) #4587*/
export const EXPLANATORY_PROGRESS = '○：新規、　◎：継続、　△：中断、　●：完了、　▲：完了見込、　◇：予定提出後に変更、　×：該当無、　■：キャンセル、　％：実績進捗率';


/**  9pt */
export const FONT_DEFAULT = "normal normal 12px ＭＳ ゴシック";
/**  9pt BOLD */
export const FONT_DEFAULT_BOLD = "700 12px ＭＳ ゴシック";
/**  10pt */
export const FONT_MIDDLE = "normal normal 13px ＭＳ ゴシック";
/** 10pt BOLD */
export const FONT_MIDDL_BOLD = "700 13px ＭＳ ゴシック";
/** 12pt */
export const FONT_LARGE = "normal normal 16px ＭＳ ゴシック";
/** 12pt BOLD */
export const FONT_LARGE_BOLD = "700 16px ＭＳ ゴシック";
/** 14pt HGSｺﾞｼｯｸM */
export const FONT_APPROVE_HEADER = "normal normal 14px ＨＧＳゴシックＭ";

export const FONT_DEFAULT_MSGOTHIC = "normal normal 14px ＭＳ ゴシック";

//下のが良いかも
//export type GridMode = 'EDIT' | 'VIEW' | 'IMPORT' ;




///**
// * pending
// */
//export const FUNCTION_CODE = {
//    /**マスタ管理---02_MASTER */
//    F_02_MASTER: '02_MASTER',
//    /**顧客・工場マスタ---02_MST_001 */
//    F_02_MST_001: '02_MST_001',
//    /**プロジェクトマスタ---02_MST_002 */
//    F_02_MST_002: '02_MST_002',
//    /**管理者ユーザマスタ---02_MST_004 */
//    F_02_MST_004: '02_MST_004',
//    /**承認表設定---03_APPR_001 */
//    F_03_APPR_001: '03_APPR_001',
//    /**承認作業担当設定---03_APPR_002 */
//    F_03_APPR_002: '03_APPR_002',
//    /**ホールド設定---03_APPR_003 */
//    F_03_APPR_003: '03_APPR_003',
//    /**承認設定---03_APPR_SETTING */
//    F_03_APPR_SETTING: '03_APPR_SETTING',
//    /**基本設定---03_BASE_SETTING */
//    F_03_BASE_SETTING: '03_BASE_SETTING',
//    /**メール設定---03_MAIL_001 */
//    F_03_MAIL_001: '03_MAIL_001',
//    /**担当設定---03_OPERATOR_SETTING */
//    F_03_OPERATOR_SETTING: '03_OPERATOR_SETTING',
//    /**プロジェクト計画---03_PLAN */
//    F_03_PLAN: '03_PLAN',
//    /**工程表設定---03_PROC_001 */
//    F_03_PROC_001: '03_PROC_001',
//    /**進捗表設定---03_PROG_001 */
//    F_03_PROG_001: '03_PROG_001',
//    /**進捗履歴・最新実績管理---03_PROG_006 */
//    F_03_PROG_006: '03_PROG_006',
//    /**ユーザ情報---03_SET_001 */
//    F_03_SET_001: '03_SET_001',
//    /**会社情報---03_SET_002 */
//    F_03_SET_002: '03_SET_002',
//    /**プラント情報---03_SET_003 */
//    F_03_SET_003: '03_SET_003',
//    /**カテゴリ情報---03_SET_004 */
//    F_03_SET_004: '03_SET_004',
//    /**プラントカテゴリ会社設定---03_SET_005 */
//    F_03_SET_005: '03_SET_005',
//    /**テスト系統・法規情報---03_SET_006 */
//    F_03_SET_006: '03_SET_006',
//    /**機器・工事情報---03_SET_007 */
//    F_03_SET_007: '03_SET_007',
//    /**機器担当ユーザ設定---03_SET_008 */
//    F_03_SET_008: '03_SET_008',
//    /**作業担当情報---03_SET_009 */
//    F_03_SET_009: '03_SET_009',
//    /**作業担当ユーザ設定（所属会社毎） 03_SET_010 */
//    F_03_SET_010: '03_SET_010',
//    /**作業担当ユーザ設定（ユーザ毎）   03_SET_011 */
//    F_03_SET_011: '03_SET_011',
//    /**必須作業情報---03_SET_012 */
//    F_03_SET_012: '03_SET_012',
//    /**作業情報---03_SET_013 */
//    F_03_SET_013: '03_SET_013',
//    /**サマリ表設定---03_SUMM_001 */
//    F_03_SUMM_001: '03_SUMM_001',
//    /**ビュー進捗表設定---03_VPROG_001 */
//    F_03_VPROG_001: '03_VPROG_001',
//    /**体調チェック---04_ANS_001 */
//    F_04_ANS_001: '04_ANS_001',
//    /**予定承認表---04_APPR_001 */
//    F_04_APPR_001: '04_APPR_001',
//    /**予定変更---04_APPR_004 */
//    F_04_APPR_004: '04_APPR_004',
//    /**予定・実績比較---04_APPR_005 */
//    F_04_APPR_005: '04_APPR_005',
//    /**予定表---04_APPROVE */
//    F_04_APPROVE: '04_APPROVE',
//    /**カレンダー---04_CAL_001 */
//    F_04_CAL_001: '04_CAL_001',
//    /**体調チェック設定---04_CHK_001 */
//    F_04_CHK_001: '04_CHK_001',
//    /**プロジェクト情報---04_IMPLEMENT */
//    F_04_IMPLEMENT: '04_IMPLEMENT',
//    /**進捗表(通常)---04_PROG_001 */
//    F_04_PROG_001: '04_PROG_001',
//    /**進捗表(リスト)---04_PROG_002 */
//    F_04_PROG_002: '04_PROG_002',
//    /**進捗表(カレンダー)---04_PROG_003 */
//    F_04_PROG_003: '04_PROG_003',
//    /**ビュー進捗表---04_PROG_004 */
//    F_04_PROG_004: '04_PROG_004',
//    /**機器番号・名称検索---04_PROG_005 */
//    F_04_PROG_005: '04_PROG_005',
//    /**追加工事管理---04_PROG_006 */
//    F_04_PROG_006: '04_PROG_006',
//    /**進捗表---04_PROGRESS */
//    F_04_PROGRESS: '04_PROGRESS',
//    /**掲示板---04_SHR_001 */
//    F_04_SHR_001: '04_SHR_001',
//    /**ミーティング掲示板---04_SHR_004 */
//    F_04_SHR_004: '04_SHR_004',
//    /**ドキュメント情報---04_SHR_005 */
//    F_04_SHR_005: '04_SHR_005',
//    /**リンクの編集---04_SHR_008 */
//    F_04_SHR_008: '04_SHR_008',
//    /**登録された任意のリンク---04_SHR_009 */
//    F_04_SHR_009: '04_SHR_009',
//    /**サマリグラフ---04_SUM_001 */
//    F_04_SUM_001: '04_SUM_001',
//    /**サマリ表(プラント)---04_SUM_002 */
//    F_04_SUM_002: '04_SUM_002',
//    /**サマリ表(カテゴリ)---04_SUM_003 */
//    F_04_SUM_003: '04_SUM_003',
//    /**サマリ表(ミーティング)---04_SUM_004 */
//    F_04_SUM_004: '04_SUM_004',
//    /**サマリ表(全体)---04_SUM_005 */
//    F_04_SUM_005: '04_SUM_005',
//    /**サマリ表(未完了)---04_SUM_006 */
//    F_04_SUM_006: '04_SUM_006',
//    /**サマリ表(テスト系統)---04_SUM_007 */
//    F_04_SUM_007: '04_SUM_007',
//    /**サマリ表(法規)---04_SUM_008 */
//    F_04_SUM_008: '04_SUM_008',
//    /**サマリ表---04_SUMMARY */
//    F_04_SUMMARY: '04_SUMMARY',
//    /**アンケート---05_ANS_001 */
//    F_05_ANS_001: '05_ANS_001',
//    /**外部リンク---05_LINK */
//    F_05_LINK: '05_LINK',
//    /**アンケート設定---05_QUE_001 */
//    F_05_QUE_001: '05_QUE_001',
//}
